import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses?.includes(initialModel.refStatus?.key) || disabledRequestTypes?.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) {
                return false;
            }
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft", "reEditAuthority"].includes(record?.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" }) || record.isOfficerCreate) {
                if ([null, "draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = ({ dataKey }) => {
    const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refCancelSequestrateTemp.refDepartment",
                    "refCancelSequestrateTemp.cancelSequestrateDate",
                    "refCancelSequestrateTemp.regulation",
                    "refCancelSequestrateTemp.customer",
                    "refCancelSequestrateTemp.openInspector",
                    "refCancelSequestrateTemp.resultRemark",
                    "refCancelSequestrateTemp.refResult",
                    "refCancelSequestrateTemp.cause",
                    "refCancelSequestrateTemp.activity",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refCancelSequestrateTemp.refSequestrate",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, props }) => {
                const { viewOnly } = props;
                let enabled = !viewOnly;
                if (modelRef.refCancelSequestrateTemp?.refSequestrate?.id) {
                    enabled = false;
                }
                if (["4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.requestCode
            },
            inputPropField: () => {
                return true;
            }
        },
        {
            check: ({ field }) => {
                return ["refCancelSequestrateTemp.followDetail"].includes(field?.key);
            },
            visibleField: () => {
                return false
            },
        },
        {
            check: ({ field }) => {
                return ["refCancelSequestrateTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refCancelSequestrateTemp?.approveCode
            },
            inputPropField: () => {
                return true;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["refCancelSequestrate"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forApproveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refCancelSequestrateTemp\\.products\\.[^\\.]+\\.(regNo|samplingNo|analysisResult|remark)$`).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitRelease",
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refCancelSequestrateTemp\\.addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode|tel|fax)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^refCancelSequestrateTemp.addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)`, "g"),
                    new RegExp(`^refCancelSequestrateTemp.refSequestrate.addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            visibleField: () => {
                return false
            },
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refCancelSequestrateTemp\\.attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                        common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
    ];
};
